export default "__VITE_PUBLIC_ASSET__e899447f__"